<template>
  <router-link
    :to="{ name: 'OrderDetails', query: { orderNumber: orderNumber, orderSource: orderSource, dealerCode: dealerCode, salesOrg: salesOrganization }}"
  >
    {{ orderNumber }}
  </router-link>
</template>

<script>
  export default {
    props: {
      orderNumber: {
        type: String,
        default: "",
      },
      orderSource: {
        type: String,
        default: "",
      },
      dealerCode: {
        type: String,
        default: "",
      },
      salesOrganization: {
        type: String,
        default: "",
      },
    },
    computed: {
      orderLink () {
        return `/orders/details?orderNumber=${this.orderNumber}&orderSource=${this.orderSource}&salesOrg=${this.salesOrg}`
      }
    }
  }
</script>
